module.exports = __webpack_public_path__ + "img/SMT_57_Ms_Susan_See.36d77781.jpg";